import React from "react";
import styled from "styled-components";
import { ProgressBar } from "react-bootstrap";

import { useAppSelector } from "../redux/hooks";
import { selectCalculatedTripStatus, selectCurrentBusData } from "../redux/selectors";
import { lengthUnit } from "../config";

const TripProgressContainer = styled.div`
  border: none;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  align-content: center;
  div.progress-data {
    font-size: 100%;
    font-weight: bold;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  div p {
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
  }
`;

const FooterInfoProgressComponentMedium = (): JSX.Element => {
  const currentBusDataFromRedux: BusInfo = useAppSelector<BusInfo>(selectCurrentBusData);
  const calculatedTripStatusFromRedux: CalculatedTripInfo = useAppSelector<CalculatedTripInfo>(selectCalculatedTripStatus);

  return (
    <React.Fragment>
      {currentBusDataFromRedux &&
      Object.keys(currentBusDataFromRedux)?.length &&
      calculatedTripStatusFromRedux &&
      Object.keys(calculatedTripStatusFromRedux)?.length ? (
        <TripProgressContainer>
          <ProgressBar
            animated={true}
            striped={true}
            variant={
              currentBusDataFromRedux.addedStatus === "busToFast"
                ? "danger"
                : currentBusDataFromRedux.addedStatus === "busOnTime"
                  ? "success"
                  : currentBusDataFromRedux.addedStatus === "delayedBus"
                    ? "warning"
                    : "secondary"
            }
            min={0}
            max={100}
            now={calculatedTripStatusFromRedux.busPositionDistanceCoveredPercentage}
          />

          <div className="progress-data">
            <div>{calculatedTripStatusFromRedux.busPositionDistanceCoveredPercentageString}</div>
            <div>{`${calculatedTripStatusFromRedux.busPositionPolylineDistanceCovered.toFixed(
              2
            )}/${calculatedTripStatusFromRedux.currentPolylineLength.toFixed(2)} ${lengthUnit}`}</div>
          </div>

          <div>
            <p>
              Trip (direction):{" "}
              <span className="span_bold">
                {currentBusDataFromRedux?.trip || "n/a"} ({currentBusDataFromRedux.direction || "n/a"})
              </span>
            </p>
          </div>
        </TripProgressContainer>
      ) : null}
    </React.Fragment>
  );
};

export default FooterInfoProgressComponentMedium;
